import Vue from 'vue'
import VueMoment from 'vue-moment'

Vue.use(VueMoment)



// WEBPACK FOOTER //
// ./src/front/init/utils/moment.js